/**
 * Responsible for initializing the bambuser live show player
 * @module modules/bambuser
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options.js';

export const PLUGIN_NAME = 'bambuser';
export const DEFAULTS = {
  autoplay: false,
  showId: '',
  showName: '',
  type: 'overlay',
};

/**
 * Configuration options for the bambuser player and mini player
 */
const initBambuserConfig = (options) => {
  // Add configuration to the window if it doesn't already exist
  if (!window.onBambuserLiveShoppingReady) {
    /* eslint no-unused-vars: ["error", { "varsIgnorePattern": "bambuserPlayer" }] */
    let bambuserPlayer;
    window.onBambuserLiveShoppingReady = function (player) {
      player.configure({
        minimizedPosition: player.MINIMIZED_POSITION.BOTTOM_RIGHT,
        buttons: {
          checkout: player.BUTTON.MINIMIZE,
          dismiss: player.BUTTON.MINIMIZE,
          product: player.BUTTON.MINIMIZE, // Disables player cart
        },
      });
      player.on(player.EVENT.READY, () => {
        if (typeof logEngagementWithDetails === 'function') {
          logEngagementWithDetails(window.location.href, 'video_tracking',
              'video_play', `BambuserShowName=${options.showName}`);
        }
      });
      bambuserPlayer = player;
    };
  }
};

/**
 * Initialize bambuser event listeners to the target element and
 * add the bambuser script to the DOM
 * @param  {jQuery} $el - button or element that initialized bambuser
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const initBambuser = ($el, options) => {
  // Add bambuser script to the DOM if it doesn't already exist
  if (!window.initBambuserLiveShopping) {
    window.initBambuserLiveShopping = function (item) {
      window.initBambuserLiveShopping.queue.push(item);
    };
    window.initBambuserLiveShopping.queue = [];
    const scriptNode = document.createElement('script');
    scriptNode.src = 'https://lcx-embed.bambuser.com/revolve/embed.js';
    document.body.appendChild(scriptNode);
  }

  window.initBambuserLiveShopping({
    showId: options.showId,
    ...(!options.autoplay && { node: $el[0] }), // show autoplays when node is ommitted
    type: options.type,
  });
};

/**
* Initializes bambuser
* @param {HTMLElement} el - play link for bambuser video
* @param {Object} options - Options used for wiring up the progressRing
* @see DEFAULTS
*/
export default function bambuser(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  initBambuserConfig(opts);
  initBambuser($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, bambuser);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/bambuser.js